export default "__VITE_ASSET__CaR63hZz__"